import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { useExportDataBl } from '../../ExportData.bl';
import { IExportDataStore } from '../../ExportData.store';
import { ExportDataFilter } from '../../models/ExportDataFilter';
import { ExportDataForm } from './ExportDataForm';

export const ExportDataFormContainer = observer((): ReactElement => {
  const bl = useExportDataBl();
  const store = useInjection(IExportDataStore.$);

  const handleDataRangeChange = (dataFilter: ExportDataFilter): void => {
    bl.selectDataFilter(dataFilter);
  };

  return (
    <ExportDataForm
      selectedFilter={store.selectedDataFilter}
      onChangeDataRange={handleDataRangeChange}
      annotationsLastModifiedDate={store.lastAnnotationChange.toString()}
    />
  );
});
